<template>
  <form @submit.prevent="submitForm">
    <div>
      <label for="name">Name:</label>
      <input type="text" id="name" v-model="name" />
    </div>
    <div>
      <label for="email">Email:</label>
      <input id="email" v-model="suburb" />
    </div>
    <div>
      <label for="age">Age:</label>
      <input type="number" id="age" v-model.number="age" />
    </div>
    <button type="submit">Update Profile</button>
  </form>
</template>

<script>
export default {
  data() {
    return {
      name: this.$store.getters.user.firstName,
      suburb: this.$store.getters.user.suburb,
    };
  },
  methods: {
    submitForm() {
      console.log(`New Name: ${this.name}`);
      console.log(`New Email: ${this.suburb}`);
      console.log(`New Age: ${this.age}`);
    },
  },
};
</script>
